// Choisir un nouveau mot de passe, depuis le lien reçu par e-mail.
//
// LE JETON PASSE DANS LE CORPS DE LA REQUÊTE, jamais dans l'URL appelée. Il
// arrive bien dans l'adresse de cette page — c'est un lien cliquable, il n'y a
// pas d'autre moyen — mais on le sort de là pour l'envoyer au serveur. Le
// journal d'audit enregistre les chemins appelés : un jeton dans un chemin s'y
// retrouverait en clair, dans une table que d'autres personnes peuvent lire.
//
// AUCUNE CONNEXION AUTOMATIQUE après le changement. Reprendre la main sur un
// compte passe par une connexion normale, avec le mot de passe qu'on vient de
// choisir : sinon un lien intercepté vaudrait une session ouverte.
import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";

import api from "../api";
import ChampMotDePasse from "../components/ChampMotDePasse";
import { useMarque } from "../marque";

const AIDE_MOT_DE_PASSE =
  "12 caractères minimum, sans suite prévisible (1234, abcd), " +
  "sans mot courant, et sans votre adresse e-mail.";

function messageErreur(err, defaut) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail) && detail[0]?.msg) return detail[0].msg;
  return defaut;
}

export default function Reinitialiser() {
  const marque = useMarque();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const jeton = params.get("jeton") || "";

  const [nouveau, setNouveau] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [enCours, setEnCours] = useState(false);
  const [erreur, setErreur] = useState("");
  const [fait, setFait] = useState(false);

  const envoyer = (e) => {
    e.preventDefault();
    // Seule vérification faite ici : elle attrape la faute de frappe avant de
    // consommer le jeton. Un lien ne sert qu'une fois — se tromper de saisie
    // obligerait à en redemander un.
    if (nouveau !== confirmation) {
      setErreur("Les deux saisies ne correspondent pas.");
      return;
    }
    setEnCours(true);
    setErreur("");
    api
      .post("/mot-de-passe-reinitialise", {
        jeton,
        nouveau_mot_de_passe: nouveau,
      })
      .then(() => {
        setFait(true);
        setTimeout(() => navigate("/login"), 2500);
      })
      .catch((err) =>
        setErreur(messageErreur(err, "Ce lien n’est plus valable."))
      )
      .finally(() => setEnCours(false));
  };

  return (
    <div className="login-page">
      <div className="login-panel-gauche">
        {marque.logo_url ? (
          <img src={marque.logo_url} alt={marque.nom} className="login-logo" />
        ) : (
          <div className="login-titre">Gestion de flotte</div>
        )}
        <div className="login-tagline">Espace professionnel</div>
      </div>

      <div className="login-panel-droite">
        {!jeton ? (
          <div className="login-form">
            <h1 className="login-marque">Lien incomplet</h1>
            <p className="erreur">
              Cette adresse ne contient pas de jeton. Ouvrez le lien depuis
              l’e-mail reçu, sans le retaper à la main.
            </p>
            <p className="login-oubli">
              <Link to="/mot-de-passe-oublie">Demander un nouveau lien</Link>
            </p>
          </div>
        ) : fait ? (
          <div className="login-form">
            <h1 className="login-marque">Mot de passe changé</h1>
            <p className="note-succes">
              Vous pouvez maintenant vous connecter. Toutes vos autres sessions
              ont été déconnectées.
            </p>
            <p className="login-oubli">
              <Link to="/login">Aller à la connexion</Link>
            </p>
          </div>
        ) : (
          <form className="login-form" onSubmit={envoyer}>
            <h1 className="login-marque">Nouveau mot de passe</h1>

            {erreur && <div className="erreur">{erreur}</div>}

            <ChampMotDePasse
              className="login-champ"
              label="Nouveau mot de passe"
              value={nouveau}
              onChange={setNouveau}
              autoComplete="new-password"
              required
            />
            <ChampMotDePasse
              className="login-champ"
              label="Confirmer"
              value={confirmation}
              onChange={setConfirmation}
              autoComplete="new-password"
              required
            />

            <p className="sous-info">{AIDE_MOT_DE_PASSE}</p>

            <button
              className="btn-accent login-btn"
              type="submit"
              disabled={enCours || !nouveau || !confirmation}
            >
              {enCours ? "Enregistrement…" : "Changer mon mot de passe"}
            </button>

            <p className="login-oubli">
              <Link to="/login">Retour à la connexion</Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
